import {
  ACTIVATE_REBOOKING,
  ACTIVATE_PAYMENT_SCHEDULE_REBOOKING,
  CLEAR_PAYMENT_SCHEDULE_REBOOKING,
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  CHECKOUT_ADD_ITEM,
  CHECKOUT_APPLY_PARTNERSHIP_STATUS,
  CHECKOUT_APPLY_PROMO_CODE,
  CHECKOUT_APPLY_PROMO_CODE_FAILED,
  CHECKOUT_APPLY_VELOCITY_BURN,
  CHECKOUT_CLEAR_CART,
  CHECKOUT_CLEAR_VELOCITY_BURN,
  CHECKOUT_FETCHING_PROMO_CODE,
  CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_INITIALISE,
  CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
  CHECKOUT_PROCESS_CANCEL,
  CHECKOUT_PROCESS_FAILURE,
  CHECKOUT_PROCESS_START,
  CHECKOUT_PROCESS_SUCCESS,
  CHECKOUT_REMOVE_ITEM,
  CHECKOUT_RESET_FLIGHT_ITEMS,
  CHECKOUT_RESET_PROMO_CODE,
  CHECKOUT_RESTORE_CART,
  CHECKOUT_INITIALISE_FORM,
  CHECKOUT_RESTORE_PAYMENT,
  CHECKOUT_SET_FORM,
  CHECKOUT_CLEAR_TRAVELLER_FORM,
  CHECKOUT_SET_RESTORE_CART_STATUS,
  CHECKOUT_TOGGLE_DEV_TOOLS,
  CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
  CHECKOUT_SET_POST_PURCHASE,
  CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_GUEST_CHECKOUT_MODE,
  CHECKOUT_SET_SPECIAL_REQUEST,
  CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
  CHECKOUT_SET_VELOCITY_SSO,
  CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_TOGGLE_CREDIT,
  CHECKOUT_SET_CLASSIC_REWARDS,
  CHECKOUT_TOGGLE_GIFT_CARD,
  CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
  CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING, CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
  CHECKOUT_UPDATE_EXPERIENCE_ITEM,
  CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE,
  CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE,
  CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
  CHECKOUT_UPDATE_ITEM,
  CHECKOUT_REPLACE_INSURANCE_SELECTION,
  CHECKOUT_UPDATE_PAYMENT_SELECTION,
  CHECKOUT_SAVE_GROUP_PAYMENT,
  CHECKOUT_CLEAR_GROUP_PAYMENT,
  CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION,
  CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE,
  CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY,
  CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY,
  CHECKOUT_SET_SAVE_CARD_AS_LUX_PLUS_BACKUP,
  CHECKOUT_SET_MULTI_CART_ITEM_MODE,
  CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
  CHECKOUT_SET_SPLIT_MERCHANT_FEE_AMOUNT,
  CHECKOUT_SET_INLINE_SPLIT_ACTIVE,
  CHECKOUT_SET_SPLIT_CARD_LEGS,
  CHECKOUT_RESET_FORM,
  CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  CHECKOUT_AGENT_BOOKING_DETAILS,
  CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
  CHECKOUT_SET_DISPLAYED_PAYMENT_METHOD,
  CHECKOUT_ADD_ARRIVAL_DETAILS,
  CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
  CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
  CHECKOUT_SET_PAYTO_BANK, CHECKOUT_SET_COMMS_RESUBSCRIBE,
  CHECKOUT_FETCHING_PAYMENT_LINK,
  CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
  CHECKOUT_SET_PAYMENT_LINK,
  CHECKOUT_SET_VOUCHER_IDS,
  CHECKOUT_CLEAR_VOUCHER_IDS,
  CHECKOUT_SET_AGENT_REQUEST_3DS,
  CHECKOUT_SET_ORDER_ID,
  CHECKOUT_RESET_COMMISSION,
  CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
  CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_SET_MODE,
  CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
  CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
  SET_BEDBANK_SESSION,
  CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
  CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
  SET_PAYPAL_PAYMENT_TYPE,
  CHECKOUT_TOGGLE_FAILED_ITEMS,
  CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS,
  CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS,
  CHECKOUT_UPDATE_FLIGHT_BAGGAGE_SELECTIONS,
  CHECKOUT_CLEAR_FLIGHT_BAGGAGE_SELECTIONS,
  CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION,
  CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION,
  CHECKOUT_SET_DELIVERY_FORM,
  SET_TERMINAL_READER_ID,
  CHECKOUT_VALIDATE_OFFER_DISCOUNT,
  CHECKOUT_SET_CHARTER_UPGRADE,
  CHECKOUT_SET_PAYMENT_PROGRESS_STEP,
  CHECKOUT_SET_PAYMENT_PROGRESS_FAILED,
  PAYMENT_PROGRESS_ORDER_CREATED_STEP,
  SET_AUTO_APPLIED_VOUCHER,
} from 'actions/actionConstants'
import {
  CHECKOUT_CREATE_CART_QUOTE,
  CHECKOUT_UPDATE_CART_QUOTE,
  CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
  CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
  CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
  CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
  CREATE_STRIPE_PAYMENT_METHOD,
  FETCH_COMMMISSION_PROMO,
  FETCH_FINAL_FLIGHT_FARES,
  FETCH_TRAVELLER_FORM_SCHEMA,
  FETCH_VELOCITY_MEMBER_DETAILS,
  UPDATE_BEDBANK_SESSION,
  FETCH_COMMISSION_PROMO_CODE,
} from 'actions/apiActionConstants'
import {
  CHECKOUT_ITEM_TYPE_BEDBANK,
  CHECKOUT_ITEM_TYPE_EXPERIENCE,
} from 'constants/checkout'
import { isPrestige4nPromo } from 'checkout/constants/paymentPromotions'
import { isBundleAndSaveItem, isFlightItem } from 'lib/checkout/checkoutUtils'
import { initialFormState } from 'lib/checkout/form'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { omitKeys } from 'lib/object/objectUtils'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'
import uuidV4 from 'lib/string/uuidV4Utils'
import { VELOCITY_SSO_STATUS } from 'constants/partnerships'
import { unique } from 'lib/array/arrayUtils'
import { AGENT_HUB_PAYMENT_MODE, PAYMENT_OPTIONS } from 'constants/payment'
import { EMPTY_CLASSIC_REWARD_CHECKOUT_STATE } from 'checkout/lib/utils/classicRewards/classicRewardCheckoutState'
import { isPropertyRateLoyaltyPackageUpgradeItem } from 'checkout/lib/utils/loyalty/propertyRateLoyaltyUpgrade'

/**
 * Store a replacement enquiry session on the active side of a loyalty package upgrade.
 *
 * The toggle switches between saved source and target session ids. Update the side currently used by
 * the checkout item so later toggles cannot restore a superseded session. An applied loyalty package
 * upgrade uses the target side; a removed one uses the source side.
 */
function withEnquiredBookingSession(
  item: App.Checkout.BedbankHotelItem,
  sessionId: string,
): App.Checkout.BedbankHotelItem {
  const upgrade = item.loyaltyPropertyRateUpgrade
  if (!upgrade) return { ...item, sessionId }

  const isApplied = isPropertyRateLoyaltyPackageUpgradeItem(item)
  const booking = isApplied ? upgrade.targetBooking : upgrade.sourceBooking
  if (!booking) return { ...item, sessionId }

  return {
    ...item,
    sessionId,
    loyaltyPropertyRateUpgrade: isApplied
      ? { ...upgrade, targetBooking: { ...booking, sessionId } }
      : { ...upgrade, sourceBooking: { ...booking, sessionId } },
  }
}

function formatPromoRequestErrorMessage(error: any): string {
  const intl = getCurrentIntl()

  if (error === 'matchingCorpEmailDomainRequiredForCreate') {
    return intl.formatMessage({
      id: 'Kmoh1uByur6x0PMicdb3',
      defaultMessage: 'Email address is not valid for the coupon code',
      description: 'Error shown when the submitted email address is not eligible for the requested corporate or friends and family promo code',
    })
  }

  if (error === 'Service Error: Service Error received: 400') {
    return intl.formatMessage({
      id: 'grNU3HGKt6v3EBDbkUoS',
      defaultMessage: 'Failed to create promo code. Please try again later',
      description: 'Fallback error shown when the promo code creation request fails with a generic bad request response',
    })
  }

  return error?.message ? error.message : error.toString()
}

export const initialState: App.CheckoutState = {
  cart: {
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    cartId: null,
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    regionCode: null,
    /** @ts-ignore null is required for multi cart to initialise correct, but not on types... */
    currencyCode: null,
    items: [],
    specialRequests: {},
    transactionKey: uuidV4(),
    isGift: false,
    isDevToolsEnabled: false,
    isAbandonedCart: false,
    arrivalFlightNumber: null,
    isMultiItemMode: false,
    restoredCartDetails: undefined,
    agentBookingDetails: null,
    csCartQuoteStatus: undefined,
    csCartQuoteError: undefined,
    csCartQuoteId: undefined,
    arrivalDetails: {},
    isMultiCart: undefined,
    checkoutSource: undefined,
    checkoutSourceRequired: undefined,
    hasCarHireIntention: false,
    hasFailedItems: false,
  },
  sessions: {},
  form: initialFormState,
  payment: {
    useCredit: false,
    useGiftCard: false,
    voucherIds: [],
    paymentSelected: 'full',
    paymentScheduleBalanceType: 'next_charge',
    paymentScheduleFullBalanceOnly: false,
    partnerships: {},
    modals: {
      velocity: {
        isActive: false,
        isClean: true,
      },
    },
    dynamicPaymentScheduleFrequency: 'weekly',
    sso: {
      velocity: {
        loginStatus: VELOCITY_SSO_STATUS.LOGGED_OUT,
        isAuthenticated: false,
        token: undefined,
        isTokenExpired: false,
        paymentAttempted: undefined,
      },
    },
    agentHubPaymentMode: AGENT_HUB_PAYMENT_MODE.PAY_NET_AMOUNT,
    terminalReaderId: undefined,
    selectedStaticScheduleOptionId: null,
    saveCheckoutCardAsLuxPlusBackup: false,
  },
  classicRewards: EMPTY_CLASSIC_REWARD_CHECKOUT_STATE,
  isPaymentRestored: false,
  isFormInitialised: false,
  schemaData: {},
  fetchingSchemaData: {},
  schemaDataErrors: {},
  isFetchingVelocityData: false,
  isCartRestored: false,
  isFetchingBedbankOrder: false,
  isCreatingBedbankChangeDatesSession: false,
  promo: undefined,
  commission: undefined,
  corporatePromoForm: {
    state: 'hidden',
  },
  friendsAndFamilyPromoForm: {
    state: 'hidden',
  },
  processing: false,
  processed: false,
  cardProcessingErrorCount: 0,
  paymentProgressStep: 0,
  paymentProgressFailed: false,
  restoreCart: {
    status: 'idle',
    errorMsg: null,
    restoredCartId: undefined,
  },
  modifyFlightView: 'home',
  csDepositPercentageOverride: false,
  depositPercentage: 0,
  merchantFeePaymentType: null,
  splitPayment: {
    isActive: false,
    legs: null,
    merchantFeeAmount: null,
  },
  paypalPaymentType: null,
  displayedPaymentMethod: undefined,
  orderFailure: false,
  insuranceAgentUpsellData: undefined,
  luxPlusUpsellData: undefined,
  loyalty: {
    enrolCustomerAtCheckout: false,
    pointsToBurn: 0,
  },
  stripePaymentMethod: {
    isCreatingStripePaymentMethod: false,
    paymentMethodId: undefined,
    cardBrand: undefined,
    cardFunding: undefined,
    cardCountry: undefined,
    walletType: undefined,
  },
  selectedPayToBank: undefined,
  securePayment: {
    isFetchingLink: false,
    securePaymentLink: undefined,
    securePaymentLinkType: undefined,
  },
  orderId: undefined,
  failedTransactionKey: undefined,
  orderTransactionKey: undefined,
  commissionData: undefined,
  autoAppliedPromoCode: undefined,
  autoAppliedVoucher: undefined,
}

const apiCalls = apiReducerSwitch<App.CheckoutState>({
  [FETCH_COMMISSION_PROMO_CODE]: {
    request: () => ({
      isFetchingCommmission: true,
      commissionData: undefined,
    }),
    success: (state, action) => ({
      isFetchingCommmission: false,
      commissionData: action.data,
    }),
    failure: () => ({
      isFetchingCommmission: false,
      commissionData: undefined,
    }),
  },
  [CHECKOUT_VALIDATE_OFFER_DISCOUNT]: {
    request: () => ({
      autoAppliedPromoCode: undefined,
    }),
    success: (_state, action) => ({
      autoAppliedPromoCode: action.data,
    }),
    failure: () => ({
      autoAppliedPromoCode: undefined,
    }),
  },
  [FETCH_TRAVELLER_FORM_SCHEMA]: {
    request: (state, action) => ({
      fetchingSchemaData: {
        ...state.fetchingSchemaData,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      schemaData: {
        ...state.schemaData,
        [action.key]: action.data,
      },
      fetchingSchemaData: {
        ...state.fetchingSchemaData,
        [action.key]: false,
      },
    }),
    failure: (state, action) => {
      return {
        fetchingSchemaData: {
          ...state.fetchingSchemaData,
          [action.key]: false,
        },
        schemaDataErrors: {
          ...state.schemaDataErrors,
          [action.key]: {
            name: action.error.message,
            status: action.error.status,
          },
        },
      }
    },
  },
  [UPDATE_BEDBANK_SESSION]: {
    request: (state, action) => {
      if (!action.sessionId) {
        return
      }
      return {
        sessions: {
          ...state.sessions,
          [action.sessionId]: {
            state: 'updating',
            data: null,
          },
        },
      }
    },
    success: (state, action) => {
      // Assumption, there is only a single bedbank offer (possibly multiple rooms) in the cart
      const { sessionId, oldSessionId, itemIds } = action.data
      const newCartItems = state.cart.items.map((item) => {
        if (item.itemType !== CHECKOUT_ITEM_TYPE_BEDBANK) { return item }
        // A first enquiry has no old session to match on — every item without one would look like a
        // match — so those are identified by the ids the enquiry was made for.
        const isEnquiredItem = oldSessionId ? item.sessionId === oldSessionId : !!itemIds?.includes(item.itemId)
        if (!isEnquiredItem) { return item }
        return withEnquiredBookingSession(item, sessionId)
      })

      return {
        cart: { ...state.cart, items: newCartItems },
        // A first enquiry has no prior entry to mark superseded. The key is omitted rather than set to
        // `undefined` because the reducer merges by spreading, so sending it would blank every session
        // in the cart, not just skip this one.
        ...(oldSessionId && {
          sessions: {
            ...state.sessions,
            [oldSessionId]: {
              state: 'updated' as const,
              data: null,
            },
          },
        }),
      }
    },
  },
  [CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO]: {
    request: (state, action) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        emailSubmitted: action.submittedEmail,
        state: 'loading',
      },
    }),
    success: (state) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        state: 'done',
        error: undefined,
      },
    }),
    failure: (state, action) => ({
      corporatePromoForm: {
        ...state.corporatePromoForm,
        state: 'error',
        emailSubmitted: state.corporatePromoForm.emailSubmitted,
        error: action?.error?.errors.map((m: any) => formatPromoRequestErrorMessage(m)),
      },
    }),
  },
  [CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO]: {
    request: (state, action) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        emailSubmitted: action.submittedEmail,
        state: 'loading',
      },
    }),
    success: (state) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        state: 'done',
        error: undefined,
      },
    }),
    failure: (state, action) => ({
      friendsAndFamilyPromoForm: {
        ...state.friendsAndFamilyPromoForm,
        state: 'error',
        emailSubmitted: state.friendsAndFamilyPromoForm.emailSubmitted,
        error: action?.error?.errors.map((m: any) => formatPromoRequestErrorMessage(m)),
      },
    }),
  },
  [FETCH_COMMMISSION_PROMO]: {
    request: () => ({
      isFetchingCommmission: true,
    }),
    success: (state, action) => ({
      commission: action.data,
      isFetchingCommmission: false,
    }),
    failure: () => ({
      isFetchingCommmission: false,
    }),
  },
  [CREATE_STRIPE_PAYMENT_METHOD]: {
    request: () => ({
      stripePaymentMethod: {
        isCreatingStripePaymentMethod: true,
        cardBrand: undefined,
        cardFunding: undefined,
        paymentMethodId: undefined,
        cardCountry: undefined,
        walletType: undefined,
      },
    }),
    success: (_state, action) => ({
      stripePaymentMethod: {
        isCreatingStripePaymentMethod: false,
        cardBrand: action.data.paymentMethod?.card?.brand,
        cardFunding: action.data.paymentMethod?.card?.funding,
        paymentMethodId: action.data.paymentMethod?.id,
        cardCountry: action.data.paymentMethod?.card?.country ?? undefined,
        walletType: action.data.paymentMethod?.card?.wallet?.type ?? undefined,
      },
    }),
    failure: (state) => ({
      stripePaymentMethod: {
        ...state.stripePaymentMethod,
        isCreatingStripePaymentMethod: false,
      },
    }),
  },
  [CHECKOUT_CREATE_CART_QUOTE]: {
    request: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'loading',
      },
    }),
    success: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteId: action.data.id,
        csCartQuoteStatus: 'created',
      },
    }),
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'error',
        csCartQuoteError: action.error,
      },
    }),
  },
  [CHECKOUT_UPDATE_CART_QUOTE]: {
    request: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'loading',
      },
    }),
    success: (state) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'created',
      },
    }),
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        csCartQuoteStatus: 'error',
        csCartQuoteError: action.error,
      },
    }),
  },
  [CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER]: {
    request: () => ({
      isCartRestored: false,
      isFetchingBedbankOrder: true,
    }),
    success: () => ({
      isCartRestored: true,
      isFetchingBedbankOrder: false,
    }),
    failure: () => ({
      isCartRestored: false,
      isFetchingBedbankOrder: false,
    }),
  },
  [CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION]: {
    request: () => ({
      isCreatingBedbankChangeDatesSession: true,
    }),
    success: () => ({
      isCreatingBedbankChangeDatesSession: false,
    }),
    failure: () => ({
      isCreatingBedbankChangeDatesSession: false,
    }),
  },
  [FETCH_FINAL_FLIGHT_FARES]: {
    request: (state, action) => {
      const { itemId } = action
      return {
        cart: {
          ...state.cart,
          items: state.cart.items.map((item) =>
            (!isFlightItemIdMatch(item, itemId)) ? item : {
              ...item,
              hasFinalFare: false,
              fetchingFare: true,
              fareFetchError: undefined,
            }),
        },
      }
    },
    success: (state, action) => {
      const { itemId, data } = action
      const flightFareData = data as typeof data & {
        fareFamilyCosts?: Array<App.FlightFareFamily['cost'] | undefined>
        isFnFBooking: boolean
        fnfPromoCodeApplicable: boolean
      }

      return {
        cart: {
          ...state.cart,
          items: state.cart.items.map(item =>
            (!isFlightItemIdMatch(item, itemId)) ? item : {
              ...item,
              totalFare: flightFareData.totalFare,
              otherFees: flightFareData.otherFees,
              isFnFBooking: flightFareData.isFnFBooking,
              fnfPromoCodeApplicable: flightFareData.fnfPromoCodeApplicable,
              flights: item.flights?.map((flight, index) => {
                const cost = flightFareData.costs[index]
                const fareFamilyCost = flightFareData.fareFamilyCosts?.[index]
                if (!flight.fareFamily?.cost) {
                  return {
                    ...flight,
                    cost,
                  }
                }

                return {
                  ...flight,
                  cost,
                  fareFamily: {
                    ...flight.fareFamily,
                    cost: fareFamilyCost ?? flight.fareFamily.cost,
                  },
                }
              }),
              hasFinalFare: true,
              fetchingFare: false,
              fareFetchError: undefined,
            }),
        },
      }
    },
    failure: (state, action) => ({
      cart: {
        ...state.cart,
        items: state.cart.items.map((item) =>
          (item.itemId !== action.itemId) ? item : {
            ...item,
            hasFinalFare: false,
            fetchingFare: false,
            fareFetchError: action.error,
          }),
      },
    }),
  },
  [FETCH_VELOCITY_MEMBER_DETAILS]: {
    request: (state) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
        },
      },
      isFetchingVelocityData: true,
    }),
    success: (state, action) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
          velocity: {
            ...state.payment.partnerships.velocity,
            burn: {
              ...state.payment.partnerships.velocity?.burn,
              membershipId: action.data.membershipId,
              pointBalance: action.data.pointBalance,
              firstName: action.data.firstName,
              lastName: action.data.lastName,
            },

          },
        },
      },
      isFetchingVelocityData: false,
    }),
    failure: (state) => ({
      payment: {
        ...state.payment,
        partnerships: {
          ...state.payment.partnerships,
        },
      },
      isFetchingVelocityData: false,
    }),
  },
})

const isFlightItemIdMatch = (
  item: App.Checkout.AnyItem,
  itemId: string,
): item is App.Checkout.FlightItem => {
  return item.itemId === itemId
}

export default createAppReducer<App.CheckoutState>(initialState, {
  [API_CALL_REQUEST]: apiCalls,
  [API_CALL_FAILURE]: apiCalls,
  [API_CALL_SUCCESS]: apiCalls,
  [CHECKOUT_INITIALISE]: (state, action) => {
    const transactionKey = action.params.cartTransactionKey ?? uuidV4()
    return {
      ...initialState,
      sessions: state.sessions,
      cart: {
        ...initialState.cart,
        cartId: transactionKey,
        regionCode: action.params.regionCode,
        currencyCode: action.params.currencyCode,
        items: Array.isArray(action.items) ? action.items : [],
        transactionKey,
        isGift: action.params.isGift,
        isAbandonedCart: false,
        isMultiItemMode: state.cart.isMultiItemMode,
        mode: action.params.mode ?? 'default',
        existingOrder: action.params.order,
        connectedRoomOfferIds: action.params.connectedRoomOfferIds,
        isMultiCart: action.params.isMultiCart,
        restoredCartDetails: action.params.restoreCartDetails,
        checkoutSource: action.params.checkoutSource,
        checkoutSourceRequired: action.params.checkoutSourceRequired,
        conversationId: action.params.conversationId,
        postPurchasePaymentSchedule: action.params.postPurchasePaymentSchedule,
      },
      isCartRestored: true,
      isFormInitialised: false,
    }
  },
  [CHECKOUT_RESTORE_CART]: (state, action) => {
    const restoredCart = { ...state.cart, ...action.cartState, isAbandonedCart: false }
    if (!Array.isArray(restoredCart.items)) {
      restoredCart.items = Array.isArray(state.cart.items) ? state.cart.items : []
    }
    return {
      cart: restoredCart,
      isCartRestored: true,
      classicRewards: EMPTY_CLASSIC_REWARD_CHECKOUT_STATE,
    }
  },
  [CHECKOUT_RESTORE_PAYMENT]: (state, action) => ({
    payment: { ...state.payment, ...action.state },
    isPaymentRestored: true,
  }),
  [CHECKOUT_CLEAR_CART]: (state) => ({
    ...state,
    displayedPaymentMethod: undefined,
    splitPayment: initialState.splitPayment,
    cart: {
      ...initialState.cart,
    },
  }),
  [CHECKOUT_CLEAR_CART_RESTORE_PRICE]: (state) => ({
    ...state,
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    },
  }),
  [CHECKOUT_INITIALISE_FORM]: (state, action) => ({
    form: action.formState ? { ...state.form, ...action.formState } : state.form,
    isFormInitialised: true,
  }),
  [CHECKOUT_RESET_FORM]: () => ({
    form: initialFormState,
  }),
  [CHECKOUT_RESET_COMMISSION]: () => ({
    commissionData: undefined,
    commission: undefined,
  }),
  [CHECKOUT_SET_COMMS_RESUBSCRIBE]: (state, action) => ({
    form: {
      ...state.form,
      commsResubscribe: action.commsResubscribe,
    },
  }),
  [CHECKOUT_UPDATE_ITEM]: (state, action) => {
    // Preserve ordering of items
    const idx = state.cart.items.findIndex(item => item.itemId === action.item.itemId)
    const newItems = idx === -1 ?
        [...state.cart.items, action.item] :
        [...state.cart.items.slice(0, idx), action.item, ...state.cart.items.slice(idx + 1)]
    const itemCountChanged = newItems.length !== state.cart.items.length
    return {
      cart: {
        ...state.cart,
        items: newItems,
        restoredCartDetails: itemCountChanged ? {
          ...state.cart.restoredCartDetails,
          originalMemberTotal: undefined,
          originalTotal: undefined,
        } : state.cart.restoredCartDetails,
      },
    }
  },
  [CHECKOUT_REPLACE_INSURANCE_SELECTION]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        items: action.items,
        restoredCartDetails: action.restoredCartDetails,
      },
    }
  },
  [CHECKOUT_ADD_ITEM]: (state, action) => ({
    cart: {
      ...state.cart,
      items: [...state.cart.items, action.item],
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        originalMemberTotal: undefined,
        originalTotal: undefined,
      },
    },
  }),
  [CHECKOUT_REMOVE_ITEM]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        items: state.cart.items.filter(item => item.itemId !== action.itemId),
        specialRequests: omitKeys([action.itemId], state.cart.specialRequests),
        restoredCartDetails: {
          ...state.cart.restoredCartDetails,
          originalMemberTotal: undefined,
          originalTotal: undefined,
        },
      },
    }
  },
  [CHECKOUT_SET_FORM]: (state, action) => ({
    form: action.form,
  }),
  [CHECKOUT_CLEAR_TRAVELLER_FORM]: (state, action) => ({
    form: {
      ...state.form,
      travellerForms: state.form.travellerForms.filter(f => f.id !== action.travellerId),
    },
  }),
  [CHECKOUT_UPDATE_PAYMENT_SELECTION]: (state, action) => ({
    payment: {
      ...state.payment,
      paymentSelected: action.paymentSelected,
      ...(action.paymentSelected !== 'payment_schedule' && { selectedStaticScheduleOptionId: null }),
      ...(action.paymentSelected !== 'group_payment' && { groupPayment: undefined }),
    },
  }),
  [CHECKOUT_SAVE_GROUP_PAYMENT]: (state, action) => ({
    payment: {
      ...state.payment,
      groupPayment: {
        allocation: action.allocation,
        preview: action.preview,
        fingerprint: action.fingerprint,
      },
    },
  }),
  [CHECKOUT_CLEAR_GROUP_PAYMENT]: (state) => ({
    payment: {
      ...state.payment,
      groupPayment: undefined,
    },
  }),
  [CHECKOUT_SELECT_STATIC_SCHEDULE_OPTION]: (state, action) => ({
    payment: {
      ...state.payment,
      selectedStaticScheduleOptionId: action.selectedStaticScheduleOptionId,
    },
  }),
  [CHECKOUT_SET_AGENT_REQUEST_3DS]: (state, action) => ({
    payment: {
      ...state.payment,
      agentRequest3ds: action.value,
    },
  }),
  [CHECKOUT_SET_PAYMENT_SCHEDULE_BALANCE_TYPE]: (state, action) => ({
    payment: {
      ...state.payment,
      paymentScheduleBalanceType: action.paymentScheduleBalanceType,
    },
  }),
  [CHECKOUT_SET_PAYMENT_SCHEDULE_FULL_BALANCE_ONLY]: (state, action) => ({
    payment: {
      ...state.payment,
      paymentScheduleFullBalanceOnly: action.paymentScheduleFullBalanceOnly,
    },
  }),
  [CHECKOUT_SET_DYNAMIC_PAYMENT_SCHEDULE_FREQUENCY]: (state, action) => ({
    payment: {
      ...state.payment,
      dynamicPaymentScheduleFrequency: action.dynamicPaymentScheduleFrequency,
    },
  }),
  [CHECKOUT_SET_SAVE_CARD_AS_LUX_PLUS_BACKUP]: (state, action) => ({
    payment: {
      ...state.payment,
      saveCheckoutCardAsLuxPlusBackup: action.saveCheckoutCardAsLuxPlusBackup,
    },
  }),
  [SET_TERMINAL_READER_ID]: (state, action) => ({
    payment: {
      ...state.payment,
      terminalReaderId: action.readerId,
    },
  }),
  [CHECKOUT_SET_SPECIAL_REQUEST]: (state, action) => ({
    cart: {
      ...state.cart,
      specialRequests: {
        ...state.cart.specialRequests,
        [action.itemId]: action.request,
      },
    },
  }),
  [CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED]: (state, action) => ({
    cart: {
      ...state.cart,
      connectedRoomOfferIds: unique([
        ...(state.cart.connectedRoomOfferIds ?? []),
        action.offerId,
      ]),
    },
  }),
  [CHECKOUT_SET_GUEST_CHECKOUT_MODE]: (state, action) => ({
    cart: {
      ...state.cart,
      isGuestCheckoutMode: action.enabled,
    },
  }),
  [CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        connectedRoomOfferIds: (state.cart.connectedRoomOfferIds ?? []).filter(id => id !== action.offerId),
      },
    }
  },
  [CHECKOUT_SET_LUXPLUS_UPSELL_DATA]: (state, action) => ({
    ...state,
    luxPlusUpsellData: action.eventData,
  }),
  [CHECKOUT_PROCESS_START]: (state) => ({
    error: undefined,
    processing: true,
    processed: false,
    orderId: undefined,
    paymentProgressStep: 0,
    paymentProgressFailed: false,
    // Store the current transaction key before order processing starts
    orderTransactionKey: state.cart.transactionKey,
  }),
  [CHECKOUT_PROCESS_CANCEL]: (state) => {
    return {
      ...state,
      cart: {
        ...state.cart,
        transactionKey: uuidV4(),
        items: state.cart.items.map(item => ({ ...item, transactionKey: uuidV4() })),
      },
      processing: false,
      processed: false,
      orderFailure: true,
      orderId: undefined,
      paymentProgressStep: 0,
      paymentProgressFailed: false,
      // Store the transactionKey from when the order was created, not the current cart transactionKey
      failedTransactionKey: state.orderTransactionKey,
    }
  },
  [CHECKOUT_PROCESS_SUCCESS]: (_state) => ({
    ...initialState,
    processing: false,
    processed: true,
    orderFailure: false,
    failedTransactionKey: undefined,
    orderTransactionKey: undefined,
  }),
  [CHECKOUT_PROCESS_FAILURE]: (state, action) => ({
    cart: {
      ...state.cart,
      transactionKey: uuidV4(),
      items: state.cart.items.map(item => ({ ...item, transactionKey: uuidV4() })),
    },
    processing: false,
    processed: false,
    paymentProgressStep: 0,
    paymentProgressFailed: false,
    cardProcessingErrorCount: action.data.errorMsg?.includes(
      'An error occurred while processing your card',
    ) ? state.cardProcessingErrorCount + 1 : state.cardProcessingErrorCount,
    // See https://github.com/lux-group/www-le-customer/pull/4393 for explanation of this
    orderFailure: true,
    // Store the transactionKey from when the order was created for failed transactions
    failedTransactionKey: state.orderTransactionKey,
  }),
  [CHECKOUT_APPLY_VELOCITY_BURN]: (state, action) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        velocity: {
          ...state.payment.partnerships.velocity,
          burn: {
            ...state.payment.partnerships.velocity?.burn,
            pointsBurned: action.points,
            isApplied: true,
          },
        },
      },
      modals: {
        ...state.payment.modals,
        isVelocityBurnActive: false,
      },
    },
  }),
  [CHECKOUT_CLEAR_VELOCITY_BURN]: (state) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        velocity: {
          ...state.payment.partnerships.velocity,
          burn: {
            ...state.payment.partnerships.velocity?.burn,
            pointsBurned: 0,
            isApplied: false,
          },
        },
      },
    },
  }),
  [CHECKOUT_APPLY_PARTNERSHIP_STATUS]: (state, action) => ({
    payment: {
      ...state.payment,
      partnerships: {
        ...state.payment.partnerships,
        [action.partnership]: {
          ...state.payment.partnerships[action.partnership],
          burn: {
            ...state.payment.partnerships[action.partnership]?.burn,
            isApplied: action.status,
          },
        },
      },
    },
  }),
  [CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS]: (state, action) => ({
    payment: {
      ...state.payment,
      modals: {
        ...state.payment.modals,
        velocity: {
          ...state.payment.modals.velocity,
          ...action.data,
        },
      },
    },
  }),
  [CHECKOUT_TOGGLE_CREDIT]: (state, action) => ({
    payment: {
      ...state.payment,
      useCredit: action.useCredit ?? !state.payment.useCredit,
    },
  }),
  [CHECKOUT_TOGGLE_GIFT_CARD]: (state) => ({
    payment: {
      ...state.payment,
      useGiftCard: !state.payment.useGiftCard,
    },
  }),
  [CHECKOUT_SET_CLASSIC_REWARDS]: (_state, action) => ({
    classicRewards: action.classicRewards,
  }),
  [CHECKOUT_TOGGLE_LOYALTY_SIGNUP]: (state, action) => {
    return {
      loyalty: {
        ...state.loyalty,
        enrolCustomerAtCheckout: action.enrolLoyalty,
      },
    }
  },
  [CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN]: (state, action) => {
    return {
      loyalty: {
        ...state.loyalty,
        pointsToBurn: action.pointsToBurn,
      },
    }
  },
  [CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN]: (state, action) => {
    return {
      cart: {
        ...state.cart,
        restoredCartDetails: {
          ...state.cart.restoredCartDetails,
          pointsToBurn: undefined,
        },
      },
      loyalty: {
        ...state.loyalty,
        pointsToBurn: action.pointsToBurn,
      },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const flightItem = state.cart.items[itemIdx] as App.Checkout.FlightItem
    const flightData = flightItem.flights[action.flightIndex]

    const newFlights = flightItem.flights.map((flight, index) => {
      if (index === action.flightIndex) {
        return {
          ...flightData,
          extras: {
            ...flightData.extras,
            baggage: action.paxBaggageMap,
          },
        }
      }

      return flight
    })

    const newFlightItem = { ...flightItem, flights: newFlights }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newFlightItem, ...state.cart.items.slice(itemIdx + 1)]

    return {
      cart: { ...state.cart, items: newItemList },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_SEAT_SELECTIONS]: (state, action) => {
    const currentSelections = state.form.flightSeatSelections ?? {}
    const hasSeatSelections = Object.values(action.seatSelections ?? {}).some((travellerSeats) => {
      return travellerSeats && Object.keys(travellerSeats).length > 0
    })

    if (!hasSeatSelections) {
      if (!(action.key in currentSelections)) { return }

      const { [action.key]: _removed, ...remaining } = currentSelections
      return {
        form: {
          ...state.form,
          flightSeatSelections: remaining,
        },
      }
    }

    return {
      form: {
        ...state.form,
        flightSeatSelections: {
          ...currentSelections,
          [action.key]: action.seatSelections,
        },
      },
    }
  },
  [CHECKOUT_CLEAR_FLIGHT_SEAT_SELECTIONS]: (state) => {
    return {
      form: {
        ...state.form,
        flightSeatSelections: {},
      },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_BAGGAGE_SELECTIONS]: (state, action) => {
    const currentSelections = state.form.flightBaggageSelections ?? {}
    const hasBaggageSelections = Object.keys(action.baggageSelections ?? {}).length > 0

    if (!hasBaggageSelections) {
      if (!(action.key in currentSelections)) { return }

      const { [action.key]: _removed, ...remaining } = currentSelections
      return {
        form: {
          ...state.form,
          flightBaggageSelections: remaining,
        },
      }
    }

    return {
      form: {
        ...state.form,
        flightBaggageSelections: {
          ...currentSelections,
          [action.key]: action.baggageSelections,
        },
      },
    }
  },
  [CHECKOUT_CLEAR_FLIGHT_BAGGAGE_SELECTIONS]: (state, action) => {
    const currentSelections = state.form.flightBaggageSelections ?? {}
    if (action.key) {
      if (!(action.key in currentSelections)) { return }

      const { [action.key]: _removed, ...remaining } = currentSelections
      return {
        form: {
          ...state.form,
          flightBaggageSelections: remaining,
        },
      }
    }
    return {
      form: {
        ...state.form,
        flightBaggageSelections: {},
      },
    }
  },
  [CHECKOUT_UPDATE_ECONOMY_LUX_COUPLES_CONFIGURATION]: (state, action) => {
    return {
      form: {
        ...state.form,
        economyLuxCouplesConfiguration: action.configuration,
      },
    }
  },
  [CHECKOUT_CLEAR_ECONOMY_LUX_COUPLES_CONFIGURATION]: (state) => {
    return {
      form: {
        ...state.form,
        economyLuxCouplesConfiguration: undefined,
      },
    }
  },
  [CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const { newFlightLegFares, newDepartingTotalFare, newReturningTotalFare, newTotalFare, newBookingFee } = action

    const flightItem = state.cart.items[itemIdx] as App.Checkout.FlightItem
    const departing = flightItem.flights[0] ? { ...(flightItem.flights[0]) } : undefined
    const returning = flightItem.flights[1] ? { ...flightItem.flights[1] } : undefined

    if (departing && newDepartingTotalFare !== undefined) {
      departing.cost = newDepartingTotalFare
    }

    if (returning && newReturningTotalFare !== undefined) {
      returning.cost = newReturningTotalFare
    }

    const flights = flightItem.flights.map((flight, index) => {
      let cost = flight.cost

      if (newFlightLegFares && newFlightLegFares.length === flightItem.flights.length) {
        const legFare = newFlightLegFares[index]
        if (legFare !== undefined) {
          cost = legFare
        }
      } else if (index === 0 && newDepartingTotalFare !== undefined) {
        cost = newDepartingTotalFare
      } else if (index === 1 && newReturningTotalFare !== undefined) {
        cost = newReturningTotalFare
      }

      if (cost === flight.cost) {
        return flight
      }

      // CRITICAL: Update BOTH flight.cost AND flight.fareFamily.cost.all
      // Some selectors read from fareFamily.cost.all instead of flight.cost
      const baseFlight = {
        ...flight,
        cost,
      }

      // If fareFamily exists, also update fareFamily.cost.all
      if (flight.fareFamily?.cost) {
        return {
          ...baseFlight,
          fareFamily: {
            ...flight.fareFamily,
            cost: {
              ...flight.fareFamily.cost,
              all: cost,
            },
          },
        } as App.Checkout.FlightItemFlight
      }

      return baseFlight
    })

    let mergedOtherFees: App.Checkout.FlightFees | undefined = undefined
    if (newBookingFee !== undefined) {
      mergedOtherFees = {
        flightBookingFee: newBookingFee,
        flightServiceFee: flightItem.otherFees?.flightServiceFee ?? 0,
        flightCreditFee: flightItem.otherFees?.flightCreditFee ?? 0,
        flightAtolFee: flightItem.otherFees?.flightAtolFee ?? 0,
      }
      if (flightItem.otherFees?.flightBaggageTotal !== undefined) {
        mergedOtherFees.flightBaggageTotal = flightItem.otherFees.flightBaggageTotal
      }
      if (flightItem.otherFees?.flightSelectedSeatsTotal !== undefined) {
        mergedOtherFees.flightSelectedSeatsTotal = flightItem.otherFees.flightSelectedSeatsTotal
      }
      if (flightItem.otherFees?.flightBaggageAddonTotal !== undefined) {
        mergedOtherFees.flightBaggageAddonTotal = flightItem.otherFees.flightBaggageAddonTotal
      }
    }

    const newFlightItem = {
      ...flightItem,
      totalFare: newTotalFare,
      flights,
      departing,
      returning,
      ...(mergedOtherFees ? { otherFees: mergedOtherFees } : {}),
    }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newFlightItem, ...state.cart.items.slice(itemIdx + 1)]
    return { cart: { ...state.cart, items: newItemList } }
  },
  [CHECKOUT_UPDATE_EXPERIENCE_ITEM]: (state, action) => {
    const idx = state.cart.items.findIndex(item => item.itemType === CHECKOUT_ITEM_TYPE_EXPERIENCE && item.experienceId === action.id)
    if (idx === -1) { return {} }

    const experienceItem = state.cart.items[idx] as App.Checkout.ExperienceItem
    const newExperienceItem = {
      ...experienceItem,
      ...action.data.details,
      tickets: action.data?.tickets ?? experienceItem.tickets,
    }

    // Preserve ordering of cart items
    const newItemList = [...state.cart.items.slice(0, idx), newExperienceItem, ...state.cart.items.slice(idx + 1)]
    return {
      cart: { ...state.cart, items: newItemList },
    }
  },
  [CHECKOUT_APPLY_PROMO_CODE]: (state, action) => {
    const velocity = state.payment.partnerships.velocity ? {
      ...state.payment.partnerships.velocity,
      pointsBurned: 0, // Invalidate the partnership
    } : null

    const shouldDisableCreditAndLoyalty = isPrestige4nPromo(action.promotion.code)

    const payment = {
      ...state.payment,
      partnerships: {
        ...(velocity && { velocity }),
      },
      ...(shouldDisableCreditAndLoyalty ? { useCredit: false } : {}),
    }

    return {
      promo: action.promotion,
      payment,
      ...(shouldDisableCreditAndLoyalty ? { loyalty: { ...state.loyalty, pointsToBurn: 0 } } : {}),
      isFetchingPromo: false,
    }
  },
  [CHECKOUT_RESET_PROMO_CODE]: (state) => ({
    promo: undefined,
    fetchingPromoError: undefined,
    payment: {
      ...state.payment,
      promoCode: undefined,
    },
  }),
  [CHECKOUT_FETCHING_PROMO_CODE]: () => ({
    isFetchingPromo: true,
    fetchingPromoError: undefined,
    autoAppliedPromoCode: undefined,
    autoAppliedVoucher: undefined,
  }),
  [CHECKOUT_APPLY_PROMO_CODE_FAILED]: (state, action) => ({
    fetchingPromoError: action.error,
    isFetchingPromo: false,
  }),
  [CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS]: (state, action) => ({
    corporatePromoForm: {
      state: 'pending-input',
      sourceCodeName: action.promoCode,
      allowedEmailDomains: action.allowedEmailDomains,
      corporateName: action.corporateName,
    },
    isFetchingPromo: false,
  }),
  [SET_AUTO_APPLIED_VOUCHER]: (_state, action) => ({
    autoAppliedVoucher: action.data,
  }),
  [CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS]: (state) => ({
    corporatePromoForm: {
      state: 'hidden',
      error: undefined,
      emailSubmitted: state.corporatePromoForm.emailSubmitted,
    },
  }),
  [CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY]: (state, action) => ({
    friendsAndFamilyPromoForm: {
      state: 'pending-input',
      sourceCodeName: action.promoCode,
      category: action.category,
    },
    isFetchingPromo: false,
  }),
  [CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY]: () => ({
    friendsAndFamilyPromoForm: {
      state: 'hidden',
    },
  }),
  [CHECKOUT_RESET_FLIGHT_ITEMS]: (state) => ({
    cart: {
      ...state.cart,
      items: state.cart.items.filter(item => !isFlightItem(item)),
    },
  }),
  [CHECKOUT_SET_RESTORE_CART_STATUS]: (state, action) => ({
    restoreCart: {
      ...state.restoreCart,
      ...action.data,
    },
  }),
  [CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW]: (state, action) => ({
    modifyFlightView: action.modifyFlightView,
  }),
  [CHECKOUT_UPDATE_HOTEL_ITEM_PRICING]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const hotelItem = state.cart.items[itemIdx]
    const newHotelItem = {
      ...hotelItem,
      newPrice: action.newPrice,
      newSurcharge: action.surcharge?.newSurcharge,
      newExtraGuestSurcharge: action.surcharge?.newExtraGuestSurcharge,
    }

    // Preserve ordering of items
    const newItemList = [...state.cart.items.slice(0, itemIdx), newHotelItem, ...state.cart.items.slice(itemIdx + 1)]
    return { cart: { ...state.cart, items: newItemList } }
  },
  [CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING]: (state, action) => {
    const itemIdx = state.cart.items.findIndex(item => item.itemId === action.itemId)
    if (itemIdx === -1) { return }

    const hotelItem = state.cart.items[itemIdx]

    if (isBundleAndSaveItem(hotelItem)) {
      const hotelData = hotelItem.dates[action.offerId]

      if (hotelData) {
        const newHotelData = {
          ...hotelData,
          newPrice: action.newPrice,
          newSurcharge: action.surcharge?.newSurcharge,
          newExtraGuestSurcharge: action.surcharge?.newExtraGuestSurcharge,
        }
        const newHotelItem = {
          ...hotelItem,
          dates: {
            ...hotelItem.dates,
            [action.offerId]: newHotelData,
          },
        }

        const newItemList = [...state.cart.items.slice(0, itemIdx), newHotelItem, ...state.cart.items.slice(itemIdx + 1)]

        return { cart: { ...state.cart, items: newItemList } }
      }
    }

    return
  },
  [CHECKOUT_TOGGLE_DEV_TOOLS]: (state) => ({
    cart: {
      ...state.cart,
      isDevToolsEnabled: !state.cart.isDevToolsEnabled,
    },
  }),
  [CHECKOUT_SET_POST_PURCHASE]: (state, action) => ({
    cart: {
      ...state.cart,
      existingOrder: action.order,
      mode: action.mode,
    },
  }),
  [CHECKOUT_SET_VELOCITY_SSO]: (state, action) => ({
    payment: {
      ...state.payment,
      sso: {
        ...state.payment.sso,
        velocity: {
          ...state.payment.sso.velocity,
          ...action.data,
        },
      },
    },
  }),
  [CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER]: (state, action) => ({
    cart: {
      ...state.cart,
      arrivalFlightNumber: action.data,
    },
  }),
  [CHECKOUT_AGENT_BOOKING_DETAILS]: (state, action) => ({
    cart: {
      ...state.cart,
      agentBookingDetails: action.data,
    },
  }),
  [CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE]: (state, action) => ({
    ...state,
    csDepositPercentageOverride: action.depositOverride,
  }),
  [ACTIVATE_REBOOKING]: (state, action) => ({
    ...state,
    payment: {
      ...state.payment,
      rebookingID: action.data.rebookingID,
    },
  }),
  [ACTIVATE_PAYMENT_SCHEDULE_REBOOKING]: (state, action) => {
    const { selectedFrequency, supplierPaymentNumberOfDays } = action.data
    // Auto-select the appropriate payment option based on whether it's a dynamic schedule
    const paymentSelected = selectedFrequency
      ? PAYMENT_OPTIONS.DYNAMIC_PAYMENT_SCHEDULE
      : PAYMENT_OPTIONS.PAYMENT_SCHEDULE
    return {
      ...state,
      payment: {
        ...state.payment,
        paymentScheduleRebookingId: action.data.paymentScheduleRebookingId,
        paymentScheduleRebookingTemplateId: action.data.scheduleTemplateId,
        paymentScheduleRebookingFrequency: selectedFrequency,
        paymentScheduleRebookingSupplierPaymentDays: supplierPaymentNumberOfDays,
        paymentSelected,
        // If dynamic schedule, also set the frequency
        ...(selectedFrequency && { dynamicPaymentScheduleFrequency: selectedFrequency }),
        // If static schedule, also set the selected option so getPaymentScheduleRequestInfo resolves it
        ...(!selectedFrequency && action.data.scheduleTemplateId && {
          selectedStaticScheduleOptionId: action.data.scheduleTemplateId,
        }),
      },
    }
  },
  [CLEAR_PAYMENT_SCHEDULE_REBOOKING]: (state) => ({
    ...state,
    payment: {
      ...state.payment,
      paymentScheduleRebookingId: undefined,
      paymentScheduleRebookingTemplateId: undefined,
      paymentScheduleRebookingFrequency: undefined,
      paymentScheduleRebookingSupplierPaymentDays: undefined,
      paymentSelected: PAYMENT_OPTIONS.FULL,
      selectedStaticScheduleOptionId: null,
    },
  }),
  [CHECKOUT_SET_MULTI_CART_ITEM_MODE]: (state, action) => ({
    ...state,
    cart: {
      ...state.cart,
      isMultiItemMode: action.isMultiItemMode,
    },
  }),
  [CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE]: (state, action) => ({
    ...state,
    merchantFeePaymentType: action.paymentType,
  }),
  [CHECKOUT_SET_SPLIT_MERCHANT_FEE_AMOUNT]: (state, action) => {
    if (state.splitPayment.merchantFeeAmount === action.amount) {
      return undefined
    }
    return {
      splitPayment: {
        ...state.splitPayment,
        merchantFeeAmount: action.amount,
      },
    }
  },
  [CHECKOUT_SET_INLINE_SPLIT_ACTIVE]: (state, action) => ({
    splitPayment: action.isActive
      ? {
          ...state.splitPayment,
          isActive: true,
        }
      : {
          ...state.splitPayment,
          isActive: false,
          legs: null,
          merchantFeeAmount: null,
        },
  }),
  [CHECKOUT_SET_SPLIT_CARD_LEGS]: (state, action) => ({
    splitPayment: {
      ...state.splitPayment,
      legs: action.legs,
    },
  }),
  [SET_PAYPAL_PAYMENT_TYPE]: (state, action) => ({
    ...state,
    paypalPaymentType: action.paymentType,
  }),
  [CHECKOUT_SET_STRIPE_PAYMENT_METHOD]: (state, action) => ({
    ...state,
    stripePaymentMethod: {
      ...state.stripePaymentMethod,
      ...action.paymentMethod,
    },
  }),
  [CHECKOUT_SET_DISPLAYED_PAYMENT_METHOD]: (state, action) => ({
    ...state,
    displayedPaymentMethod: action.paymentMethod,
  }),
  [CHECKOUT_ADD_ARRIVAL_DETAILS]: (state, action) => {
    const { itemId, arrivalDetails } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: arrivalDetails,
        },
      },
    }
  },
  [CHECKOUT_SET_ARRIVAL_DETAILS_TIME]: (state, action) => {
    const { itemId, arrivalTime } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: {
            ...state.cart.arrivalDetails[itemId],
            arrivalTime,
          },
        },
      },
    }
  },
  [CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER]: (state, action) => {
    const { itemId, arrivalFlightNumber } = action
    return {
      cart: {
        ...state.cart,
        arrivalDetails: {
          ...state.cart.arrivalDetails,
          [itemId]: {
            ...state.cart.arrivalDetails[itemId],
            arrivalFlightNumber,
          },
        },
      },
    }
  },
  [CHECKOUT_SET_PAYTO_BANK]: (state, action) => ({
    ...state,
    selectedPayToBank: action.selectedPayToBank,
  }),
  [CHECKOUT_FETCHING_PAYMENT_LINK]: () => ({
    securePayment: {
      isFetchingLink: true,
      securePaymentLink: undefined,
      securePaymentLinkType: undefined,
    },
  }),
  [CHECKOUT_FETCHING_PAYMENT_LINK_FAILED]: (state) => ({
    securePayment: {
      ...state.securePayment,
      isFetchingLink: false,
    },
  }),
  [CHECKOUT_SET_PAYMENT_LINK]: (_state, action) => ({
    securePayment: {
      isFetchingLink: false,
      securePaymentLink: action.data.securePaymentLink,
      securePaymentLinkType: action.data.securePaymentLinkType,
    },
  }),
  [CHECKOUT_SET_VOUCHER_IDS]: (state, action) => ({
    payment: {
      ...state.payment,
      voucherIds: action.voucherIds,
    },
  }),
  [CHECKOUT_CLEAR_VOUCHER_IDS]: (state) => ({
    payment: {
      ...state.payment,
      voucherIds: [],
    },
  }),
  [CHECKOUT_SET_ORDER_ID]: (state, action) => ({
    ...state,
    orderId: action.orderId,
    paymentProgressStep: PAYMENT_PROGRESS_ORDER_CREATED_STEP,
    paymentProgressFailed: false,
  }),
  [CHECKOUT_SET_PAYMENT_PROGRESS_STEP]: (state, action) => ({
    ...state,
    paymentProgressStep: action.step,
    paymentProgressFailed: false,
  }),
  [CHECKOUT_SET_PAYMENT_PROGRESS_FAILED]: (state) => ({
    ...state,
    paymentProgressFailed: true,
  }),
  [CHECKOUT_SET_MODE]: (state, action) => ({
    cart: {
      ...state.cart,
      mode: action.mode ?? 'default',
    },
  }),
  [CHECKOUT_SET_HAS_CAR_HIRE_INTENTION]: (state, action) => ({
    cart: {
      ...state.cart,
      hasCarHireIntention: action.hasCarHireIntention,
    },
  }),
  [CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP]: (state, action) => ({
    payment: {
      ...state.payment,
      agentHubPaymentMode: action.agentHubPaymentMode,
    },
  }),
  [SET_BEDBANK_SESSION]: (state, action) => ({
    sessions: {
      ...state.sessions,
      [action.data.sessionId]: {
        state: 'done',
        data: action.data,
      },
    },
  }),
  [CHECKOUT_CLEAR_RESTORED_PROMO_CODE]: (state) => ({
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        promoCode: undefined,
      },
    },
  }),
  [CHECKOUT_CLEAR_RESTORED_USE_CREDIT]: (state) => ({
    cart: {
      ...state.cart,
      restoredCartDetails: {
        ...state.cart.restoredCartDetails,
        creditsToApply: undefined,
      },
    },
  }),
  [CHECKOUT_TOGGLE_FAILED_ITEMS]: (state) => ({
    cart: {
      ...state.cart,
      hasFailedItems: true,
    },
  }),
  [CHECKOUT_SET_DELIVERY_FORM]: (state, action) => ({
    form: {
      ...state.form,
      deliveryForm: action.form,
    },
  }),
  [CHECKOUT_SET_CHARTER_UPGRADE]: (state, action) => ({
    charterUpgrade: action.details,
  }),
})
